import React, { useState } from "react"
import { Tooltip } from "reactstrap"
import infologo from "../../assets/images/lystfacelogos/info.svg"
import { isNotNullOrUndefined } from "../../common/functions"
const PasswordRules = [
  '8-16 characters length',
  '1 uppercase',
  '1 lowercase',
  '1 number',
  '1 special character'
]
function PasswordToolTip({ content, id, hideArrow }) {
  const [tooltipOpen, setTooltipOpen] = useState(false)

  const toggle = () => setTooltipOpen(!tooltipOpen)

  return (
    <div>
      <img
        src={infologo}
        rel="noreferrer"
        id={id ? id : "TooltipExample"}
        className="cursor-pointer"
      />
      <Tooltip
        isOpen={tooltipOpen}
        target={id ? id : "TooltipExample"}
        toggle={toggle}
        hideArrow={isNotNullOrUndefined(hideArrow) ? hideArrow : true}
        placement="top"

      >
        <div className="tooltip-container" >
          {content ? content :
            <>
              <p>Password must contain</p>
              <ul >
                {PasswordRules.map((ele, i) => (
                  <li key={i} style={{ textAlign: 'start' }}>{ele}</li>
                ))}
              </ul>
            </>
          }
        </div>

      </Tooltip>
    </div>
  )
}

export default PasswordToolTip
